var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1499 0C2.43382 0 1.74706 0.284463 1.24072 0.790812C0.734368 1.29716 0.449904 1.98392 0.449904 2.7V4.3137L0.131754 4.63185C0.0688398 4.69478 0.025997 4.77496 0.00864157 4.86224C-0.00871383 4.94951 0.000197527 5.03998 0.034249 5.12219C0.0683006 5.20441 0.125963 5.27468 0.199948 5.32413C0.273932 5.37358 0.360916 5.39998 0.449904 5.4H5.8499C5.93889 5.39998 6.02588 5.37358 6.09986 5.32413C6.17384 5.27468 6.23151 5.20441 6.26556 5.12219C6.29961 5.03998 6.30852 4.94951 6.29117 4.86224C6.27381 4.77496 6.23097 4.69478 6.16805 4.63185L5.8499 4.3137V2.7C5.8499 1.98392 5.56544 1.29716 5.05909 0.790812C4.55274 0.284463 3.86599 0 3.1499 0ZM3.1499 7.2C2.79186 7.2 2.44848 7.05777 2.19531 6.80459C1.94214 6.55142 1.7999 6.20804 1.7999 5.85H4.4999C4.4999 6.20804 4.35767 6.55142 4.1045 6.80459C3.85132 7.05777 3.50795 7.2 3.1499 7.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacao);
export default __webpack_public_path__ + "static/media/notificacao.0289817d21f69d79d3b00d2b3979089a.svg";
export { ForwardRef as ReactComponent };